import {
  required, minLength, email,
} from 'vuelidate/lib/validators';

const validations = {
  firstName: {
    required,
    minLength: minLength(3),
  },
  lastName: {
    required,
    minLength: minLength(3),
  },
  phoneNumber: {
    required,
  },
  countryId: {
    required,
  },
  company: {
    required,
  },
  townId: {
    required,
  },
  email: {
    required,
    email,
  },
  address: {
    required,
  },
};

export default validations;
